import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SUPPLIER_CONTACTS_FORM } from "src/app/controller/constants/forms-config";
import { ButtonIconType } from "src/app/enums/button-icon-type.enum";
import { ButtonType } from "src/app/enums/button-type.enum";
import {
  PersonModalComponent,
  PersonModalDialogType,
} from "src/app/modal/contacts/person-modal/person-modal.component";
import { AbstractFormComponent } from "../abstract-form.component";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import emojiFlags from "emoji-flags";

@Component({
    selector: "app-contacts",
    templateUrl: "./contacts.component.html",
    styleUrls: ["./contacts.component.css"],
    host: {
        class: "css-form",
    },
    standalone: false
})
export class ContactsComponent extends AbstractFormComponent implements OnInit {
  countryCodes: any[] = [];

  contactCategories: any[] = [];
  activeContactCategory: any | null = null;
  newContactCategory: string = "";

  addContactCategoryBtn: any = {
    title: "comp.title.add",
    btnType: ButtonType.SECONDARY,
    iconType: ButtonIconType.ADD,
  };

  removeContactCategoryBtn: any = {
    btnType: ButtonType.PRIMARY,
    iconType: ButtonIconType.REMOVE,
  };

  removePersonBtn: any = {
    iconType: ButtonIconType.REMOVE,
  };

  constructor(private dialog: MatDialog, httpClient: HttpClient) {
    super();
    this.http = httpClient;
  }

  ID: number = SUPPLIER_CONTACTS_FORM.ID;
  TITLE: string = SUPPLIER_CONTACTS_FORM.TITLE;
  PATH: string = SUPPLIER_CONTACTS_FORM.PATH;

  selectContactCategory(contactCategory: any) {
    this.activeContactCategory = contactCategory;
  }

  raiseEditPersonDialog(person: any, index: number) {
    this.raisePersonDialog(PersonModalDialogType.EDIT, person, index);
  }

  raiseAddPersonDialog() {
    this.raisePersonDialog(PersonModalDialogType.ADD, null, 0);
  }

  async raisePersonDialog(dialogType: PersonModalDialogType, person: any, index: number) {
    if (!this.countryCodes || this.countryCodes.length == 0) {
      await this.loadCountryCodes();
    }
    const dialogRef = this.dialog.open(PersonModalComponent, {
      data: {
        source: this,
        dialogType: dialogType,
        countryCodes: this.countryCodes,
        person: person,
        index: index
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      console.log("The dialog was closed");
    });
  }

  async loadCountryCodes() {
    let countries: any[] = [];

    for (const iso2 of getCountries()) {
      const flagData = emojiFlags.countryCode(iso2);
      countries.push({
        code: '+' + getCountryCallingCode(iso2),
        flag: flagData?.emoji || "",
      });
    }

    this.countryCodes = countries.filter((element, index) => {
      return countries.indexOf(element) === index;
    });
  }
  
  addContactCategory() {
    this.contactCategories.push({
      ident: `custom-${this.newContactCategory}`,
      name: this.newContactCategory,
      persons: []
    });
  }

  removeContactCategory(index: number) {
    this.contactCategories.splice(index, 1);
  }

  addPerson(person: any) {
    this.activeContactCategory.persons.push(person);
  }

  editPerson(person: any, index: number) {
    this.removePerson(index);
    this.activeContactCategory.persons.splice(index, 0, person);
  }


  removePerson(index: number) {
    this.activeContactCategory.persons.splice(index, 1);
  }

  getFormValues() {
    return this.contactCategories;
  }

  setFormValues(formValues: any): void {
    this.contactCategories = formValues;
  }

  getSheetName(): string {
    return "contacts";
  }

  getPersonBtnTitle(person: any) {
    return `${person.fName.substring(0, 1)}. ${person.lName}, ${
      person.position
    }`;
  }

  ngOnInit(): void {}
}
